export default __webpack_public_path__ + "76d53e3b9e2a733e7ed369db7532b41b.webp";